import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import {
    selectRefreshToken,
    setEmail,
    setFirstName,
    setLastName,
} from '../../appSlice';
import { ReactComponent as Dot } from '../../assets/icons/dot.svg';
import {
    selectRecentStations,
    setRecentStations,
} from '../../containers/HomePage/slice';
import { colors } from '../../global/variables';

import { ReactComponent as RecentIcon } from '../../assets/icons/recentIcon.svg';
import { formatDateLong } from '../../utils/utility';
import { loader } from 'graphql.macro';
import { useLazyQuery } from '@apollo/client';
import { store } from '../../app/store';

interface RecentStationsProps {
    onPress: (selection: string) => void;
    refreshKey?: number;
}
const getLatestUserDataQuery = loader(
    '../../utils/webview/getLatestUserData.graphql'
);

const RecentStations: React.FC<RecentStationsProps> = ({
    onPress,
    refreshKey = 0,
}) => {
    const refreshToken = useAppSelector(selectRefreshToken);
    const recentList = useAppSelector(selectRecentStations);
    const navigate = useNavigate();
    const [asked, setAsked] = useState(false);

    const [getRecentTransactionsForUser, { data: recentTransactionsData }] =
        useLazyQuery(getLatestUserDataQuery, {
            fetchPolicy: 'no-cache',
        });

    const scan = () => {
        navigate('/scan');
    };

    const startRecent = (stationQr: string) => {
        onPress(stationQr);
    };

    useEffect(() => {
        if (
            !recentList ||
            (recentList.length === 0 && refreshToken && !asked)
        ) {
            setAsked(true);
            getRecentTransactionsForUser();
        }
    }, [recentList]);

    useEffect(() => {
        if (refreshKey > 0 && refreshToken) {
            getRecentTransactionsForUser();
        }
    }, [refreshKey, refreshToken, getRecentTransactionsForUser]);

    useEffect(() => {
        if (
            recentTransactionsData &&
            recentTransactionsData.getUserRecentStations
        ) {
            store.dispatch(
                setRecentStations(recentTransactionsData.getUserRecentStations)
            );
        }
        if (recentTransactionsData && recentTransactionsData.loggedInUser) {
            store.dispatch(
                setFirstName(recentTransactionsData.loggedInUser.nameFirst)
            );
            store.dispatch(
                setLastName(recentTransactionsData.loggedInUser.nameLast)
            );
            store.dispatch(setEmail(recentTransactionsData.loggedInUser.email));
        }
    }, [recentTransactionsData]);

    return (
        <div className="recent" id="recent_stations_container">
            {!refreshToken && (
                <div
                    className="subcontainer recent__empty"
                    id="recent_logged_out"
                >
                    <p
                        className="recent__empty-text-logged-out"
                        id="recent__empty-text-logged-out"
                    >
                        It's easy. Plug-in, then scan to start.
                    </p>
                    <div>
                        <button
                            onClick={scan}
                            className="recent__start"
                            id="recent_start__button"
                        >
                            Scan
                        </button>
                    </div>
                </div>
            )}
            {refreshToken && recentList && recentList.length === 0 && (
                <div
                    className="subcontainer recent__empty-container"
                    id="recent_empty"
                >
                    <p className="recent__empty-text" id="recent_empty__text">
                        No recent stations
                    </p>
                </div>
            )}
            {refreshToken && recentList && recentList.length > 0 && (
                <div className="recent__container">
                    {recentList.map((item, index) => (
                        <div
                            id="recent_list__item"
                            className="subcontainer recent__stations"
                            key={index}
                            onClick={() => startRecent(item.qrCode)}
                        >
                            <RecentIcon />
                            <div
                                className="recent__details"
                                id="recent_list__item__details"
                            >
                                <div
                                    className="recent__title"
                                    id="recent_list__station_code"
                                >
                                    STATION {item.qrCode}
                                </div>
                                <div
                                    className="recent__subtitle"
                                    id="recent_list__item__subtitle"
                                >
                                    {item.address1}{' '}
                                    <Dot
                                        fill={colors.inactiveWhite}
                                        className="recent__dot"
                                    />{' '}
                                    {formatDateLong(item.startedAt)}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default RecentStations;
